/* eslint-disable jsx-a11y/click-events-have-key-events -- TODO */
"use client";

import { cn } from "../../../../utils";
import { Tooltip } from "../../../Tooltip";
import type { TableRowType } from "../../Table.types";
import { getDefaultRowId } from "../../Table.utils";
import { TableCell } from "../TableCell";
import { TableRowMobileProps } from "./Table.types.mobile";

export const TableRowMobile = <
  Row extends TableRowType,
  Group extends string = never,
>({
  row,
  column,
  classes,
  rowIndex,
  cardIndex,
  openRowIds,
  activeRowIds,
  getRowId = getDefaultRowId,
  onRowClick,
  onCellClick,
  renderRowEffect,
  renderRowExpansion,
}: TableRowMobileProps<Row, Group>) => {
  const rowId = getRowId(row, rowIndex, cardIndex);

  const isRowOpen = openRowIds?.includes(rowId) ?? false;
  const isRowActive = activeRowIds?.includes(rowId) ?? false;

  if (typeof column.isEnabled === "function" && !column.isEnabled(row))
    return null;

  return (
    <>
      <div
        role="button"
        tabIndex={-1}
        className={cn(
          "ui:relative ui:flex ui:items-center ui:justify-between ui:gap-4 ui:border-b ui:border-divider ui:last:border-b-0",
          typeof classes?.row === "string"
            ? classes.row
            : classes?.row?.({
                row,
                rowIndex,
                isRowOpen,
                isRowActive,
              }),
        )}
        onClick={() =>
          onRowClick?.({
            row,
            rowId,
            rowIndex,
          })
        }
      >
        {renderRowEffect?.({
          row,
          isActive: isRowActive,
          rowIndex,
        }) ?? null}

        <div
          className={cn(
            "ui:p-3 ui:text-xs ui:whitespace-nowrap ui:sm:px-1",
            typeof classes?.columnClassName === "string"
              ? classes?.columnClassName
              : classes?.columnClassName?.(column, rowIndex),
            column.columnClassName,
          )}
        >
          <Tooltip content={column.tooltip} disabled={!column.tooltip}>
            <span
              className={cn({
                "ui:cursor-help ui:underline": Boolean(column.tooltip),
              })}
            >
              {column.header}
            </span>
          </Tooltip>
        </div>

        <TableCell
          row={row}
          column={column}
          rowIndex={rowIndex}
          cellIndex={rowIndex}
          isRowOpen={isRowOpen}
          isRowActive={isRowActive}
          className={
            typeof classes?.cellClassName === "string"
              ? classes.cellClassName
              : classes?.cellClassName?.({
                  row,
                  column,
                  rowIndex,
                  cellIndex: rowIndex,
                })
          }
          onCellClick={onCellClick}
        />
      </div>

      {renderRowExpansion?.({
        row,
        isOpen: isRowOpen,
        rowIndex,
      }) ?? null}
    </>
  );
};
